// app/src/lib/oauth.js — the client half of the OAuth redirect flow (D-AUTH §2): the
// buttons LEAVE the SPA for /v1/auth/oauth/:provider/start (a full-page navigation, like
// the reference's /connect/* links — never a popup), carrying returnTo + the public
// uauLocale so the server can seed a brand-new account's language.

import { publicLocale } from './locale-sync.jsx';

const API_URL = import.meta.env.VITE_API_URL || ''; // '' when /v1 is same-origin (rewrite / dev proxy)

export function startOAuth(provider, { returnTo = '/' } = {}) {
  const u = new URL(`${API_URL || window.location.origin}/v1/auth/oauth/${provider}/start`);
  u.searchParams.set('returnTo', returnTo);
  u.searchParams.set('uauLocale', publicLocale());
  window.location.assign(u.toString());
}
